import React from 'react';
import { checkValidity } from '../../shared/utility';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import axios from '../../axios-admin';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Button from '@material-ui/core/Button';

const formatTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
};

class OnlineMarkerForm extends React.Component {

    state = {
        controls: {
            time: {
                value: '',
                validation: { required: true, isInt: true },
                valid: false,
                touched: false,
            },
            text: {
                value: '',
                validation: { required: true, minLength: 1 },
                valid: false,
                touched: false,
            }
        },
        formIsValid: false,
        markers: [],
        editingId: null,
    }

    componentDidMount() {
        this.fetchMarkers();
    }

    fetchMarkers() {
        axios.get('online/' + this.props.data.id + '/markers')
            .then(res => {
                this.setState({ markers: res.data.data });
            })
            .catch(err => {
                console.log(err.response);
            });
    }

    inputChangedHandler = event => {
        const inputIdentifier = event.target.id || event.target.name;

        const updatedControl = { ...this.state.controls };
        const updatedControlElement = { ...updatedControl[inputIdentifier] };

        updatedControlElement.value = event.target.value;
        updatedControlElement.valid = checkValidity(event.target.value, updatedControlElement.validation);
        updatedControlElement.touched = true;
        updatedControl[inputIdentifier] = updatedControlElement;

        let formIsValid = true;
        for (let key in updatedControl) {
            formIsValid = updatedControl[key].valid && formIsValid;
        }

        this.setState({ controls: updatedControl, formIsValid });
    }

    submitHandler(event) {
        event.preventDefault();

        if (!this.state.formIsValid) return;

        const formData = {
            time: parseInt(this.state.controls.time.value, 10),
            text: this.state.controls.text.value,
        };

        const id = this.props.data.id;
        const { editingId } = this.state;

        const request = editingId
            ? axios.post('online/' + id + '/markers/' + editingId, formData)
            : axios.post('online/' + id + '/markers', formData);

        request
            .then(() => {
                this.fetchMarkers();
                this.resetForm();
            })
            .catch(err => {
                console.log(err.response);
            });
    }

    resetForm() {
        this.setState({
            controls: {
                time: { value: '', validation: { required: true, isInt: true }, valid: false, touched: false },
                text: { value: '', validation: { required: true, minLength: 1 }, valid: false, touched: false },
            },
            formIsValid: false,
            editingId: null,
        });
    }

    editMarker(marker) {
        this.setState({
            controls: {
                time: { value: String(marker.time), validation: { required: true, isInt: true }, valid: true, touched: true },
                text: { value: marker.text, validation: { required: true, minLength: 1 }, valid: true, touched: true },
            },
            formIsValid: true,
            editingId: marker.id,
        });
    }

    deleteMarker(id) {
        axios.delete('online/' + this.props.data.id + '/markers/' + id)
            .then(() => {
                this.setState({ markers: this.state.markers.filter(m => m.id !== id) });
                if (this.state.editingId === id) this.resetForm();
            })
            .catch(err => {
                console.log(err.response);
            });
    }

    render() {
        const { controls, formIsValid, markers, editingId } = this.state;

        return (
            <form noValidate onSubmit={e => this.submitHandler(e)}>
                <Grid container spacing={16} direction="row" justify="center">
                    <Grid item sm={12}>
                        <TextField
                            id="time"
                            label="Time (seconds)"
                            type="number"
                            fullWidth
                            value={controls.time.value}
                            onChange={this.inputChangedHandler}
                            inputProps={{ min: 0 }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <TextField
                            id="text"
                            label="Marker text"
                            fullWidth
                            value={controls.text.value}
                            onChange={this.inputChangedHandler}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <Button variant="contained" fullWidth type="submit" color="primary" disabled={!formIsValid}>
                            {editingId ? 'Update Marker' : 'Add Marker'}
                        </Button>
                    </Grid>
                    {editingId && (
                        <Grid item sm={12}>
                            <Button fullWidth onClick={() => this.resetForm()}>Cancel</Button>
                        </Grid>
                    )}
                    <Grid item sm={12}>
                        <Table style={{ fontSize: '0.8em' }}>
                            <TableBody>
                                {markers.map(marker => (
                                    <TableRow key={marker.id} selected={editingId === marker.id}>
                                        <TableCell padding="none">{formatTime(marker.time)}</TableCell>
                                        <TableCell padding="none">{marker.text}</TableCell>
                                        <TableCell padding="none">
                                            <div onClick={() => this.editMarker(marker)} style={{ cursor: 'pointer', marginRight: 8, display: 'inline' }}>E</div>
                                            <div onClick={() => this.deleteMarker(marker.id)} style={{ cursor: 'pointer', display: 'inline' }}>X</div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

export default OnlineMarkerForm;
